import { tokens } from '@arvoreeducacao/bonsai-ds'
import { i18n } from 'i18n'
import React from 'react'
import {
  COMUNICAR_HOME_ROOT_PATH,
  LER_HOME_ROOT_PATH,
  SENTIR_HOME_ROOT_PATH
} from 'routes/paths'
import { Cdn } from 'utils/assets'

const lerIcon = (
  <img
    src={Cdn.getImageUrl('logos/modulo-icone-ler.png')}
    alt={i18n.t('Ler')}
  />
)
const comunicarIcon = (
  <img
    src={Cdn.getImageUrl('logos/modulo-icone-comunicar.png')}
    alt={i18n.t('Comunicar')}
  />
)
const newSentirIcon = (
  <img
    src={Cdn.getImageUrl('logos/modulo-icone-sentir.png')}
    alt={i18n.t('Sentir')}
  />
)
const newCriarIcon = (
  <img
    src={Cdn.getImageUrl('logos/modulo-icone-criar.png')}
    alt={i18n.t('Criar')}
  />
)
const superAutorIcon = (
  <img
    src={Cdn.getImageUrl(
      i18n.language === 'en-US'
        ? 'logos/super-author-badge.png'
        : 'logos/super-autor-badge.png'
    )}
    alt="SuperAutor"
    className="w-8 h-8 rounded-full object-contain mr-1"
  />
)

export const criarUrl =
  'https://livros.arvore.com.br/oidc/authorize?client_id=QHFYIJDJQMAWQVDU&response_type=code&state=%2F&redirect_uri=https://criar.arvore.com.br/oauth/arvore/redirect_url'

export const escritaUrl = '/app-v2/writing/teacher_dashboard'

export const getSuperAutorUrl = (state = '/') => {
  const redirectUri =
    i18n.language === 'en-US'
      ? 'https://app.superauthor.com/auth/callback'
      : 'https://sistema.superautor.com.br/auth/callback'
  return `https://auth.arvore.com.br/api-arvore/oauth2/authorize?client_id=arvore&response_type=code&state=${encodeURIComponent(
    state
  )}&redirect_uri=${encodeURIComponent(redirectUri)}&locale=${i18n.language}`
}

export const criarUrlWithState = (clientId: string, stateFromURL: string) => {
  return `https://livros.arvore.com.br/oidc/authorize?client_id=${clientId}&response_type=code&state=${
    stateFromURL ? stateFromURL : '%2F'
  }&redirect_uri=https://criar.arvore.com.br/oauth/arvore/redirect_url`
}

export const tabsItems = [
  {
    id: 'ler',
    icon: lerIcon,
    label: 'Ler',
    isDisabled: false,
    color: tokens.colors.blue100,
    path: LER_HOME_ROOT_PATH
  },
  {
    id: 'comunicar',
    icon: comunicarIcon,
    label: 'Comunicar',
    isDisabled: false,
    color: tokens.colors.orange100,
    path: COMUNICAR_HOME_ROOT_PATH
  },
  {
    id: 'sentir',
    icon: newSentirIcon,
    label: 'Sentir',
    isDisabled: false,
    color: tokens.colors.purple100,
    path: SENTIR_HOME_ROOT_PATH
  },
  {
    id: 'criar',
    icon: newCriarIcon,
    label: 'Criar',
    isDisabled: false
  }
]

export const superAutorTabItem = {
  id: 'criar',
  icon: superAutorIcon,
  label: i18n.language === 'en-US' ? 'SuperAuthor' : 'SuperAutor',
  isDisabled: false
}

export const mapModuleToTabId = {
  livros: 'LIVROS',
  atualidades: 'ATUALIDADES',
  comunicar: 'ENGLISH',
  sentir: 'SENTIR',
  criar: 'CRIAR'
}

export const mapNewModuleToTabId = {
  ler: 'LER',
  // TODO: alterar inglês para comunicar com a mudança no back
  comunicar: 'ENGLISH',
  sentir: 'SENTIR',
  criar: 'CRIAR'
}
